import React from "react";
import { motion } from "framer-motion";

export const Pill = ({ children, variant = "default", className = "", testid }) => {
  const variants = {
    default: "pill",
    peach: "pill accent-peach",
    lavender: "pill accent-lavender",
    sage: "pill accent-sage",
  };
  return (
    <span data-testid={testid} className={`${variants[variant] || variants.default} ${className}`}>
      {children}
    </span>
  );
};

export const SectionHeader = ({ eyebrow, title, sub, align = "left", emphasis }) => (
  <motion.div
    initial={{ opacity: 0, y: 16 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.6 }}
    className={`mb-12 md:mb-16 ${align === "center" ? "text-center mx-auto max-w-2xl" : "max-w-3xl"}`}
  >
    {eyebrow && <Pill variant="peach" testid="section-eyebrow">{eyebrow}</Pill>}
    <h2 className="mt-5 font-display text-4xl md:text-5xl lg:text-6xl font-light leading-[1.05]">
      {title}{emphasis && <em className="font-medium text-[var(--peach)] not-italic">{" "}{emphasis}</em>}
    </h2>
    {sub && <p className="mt-4 text-base md:text-lg text-[var(--text-muted)] max-w-xl">{sub}</p>}
  </motion.div>
);

export const Reveal = ({ children, delay = 0, y = 20 }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);
